module.exports = __webpack_public_path__ + "img/Group 771zh.5860b538.svg";